import { create } from 'zustand';

// Saved jobs are client-only (no backend endpoint yet) — persisted to
// localStorage so they survive reloads. Keyed by job id.
const CACHE_KEY = 'sohozkaj:savedJobs';

function loadCache() {
    try {
        const raw = localStorage.getItem(CACHE_KEY);
        if (raw) return new Set(JSON.parse(raw));
    } catch { /* ignore */ }
    return new Set();
}

function saveCache(set) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify([...set])); } catch { /* ignore */ }
}

/**
 * Per-browser saved (bookmarked) jobs. Ids are stored as strings so numeric
 * ids and slugs compare consistently.
 */
export const useSavedJobsStore = create((set, get) => ({
    saved: loadCache(),   // Set<string>

    isSaved: (id) => get().saved.has(String(id)),

    count: () => get().saved.size,

    toggle: (id) => {
        const key = String(id);
        const next = new Set(get().saved);
        next.has(key) ? next.delete(key) : next.add(key);
        saveCache(next);
        set({ saved: next });
    },
}));
